import { assertValidAppPath, isValidAppPath, type ValidAppPath } from '@/config/routes/app-paths';

export const getPathname = (path: string): string => {
  const pathnameWithHash = path.split('?')[0] ?? '';
  const pathname = pathnameWithHash.split('#')[0] ?? '';
  return pathname;
};

export const validatePath = (path: string): boolean => isValidAppPath(getPathname(path));

export const ensureValidPath = <T extends ValidAppPath>(path: T): T => {
  assertValidAppPath(path);
  return path;
};
